import request from 'api/requestUtils'
import { getDomainUserId } from 'analytics/snowplow/helpers/domainUserId'
import type { paths, definitions } from '@luxuryescapes/contract-cart'
export type CartItemLoyalty = definitions['instantHotelItem']['luxLoyalty']
export type CartRequestV2 = paths['/api/carts/v2/{cartId}']['put']['parameters']['body']['payload']
type CartSuccessResponseV2 = paths['/api/carts/v2/{cartId}']['put']['responses']['200']
export type CartItem = definitions['cartItem']
export type Brand = CartRequestV2['brand']

export function putCheckoutCart(transactionKey: string, cart: CartRequestV2) {
  return request.put<CartSuccessResponseV2, CartRequestV2>(`/api/carts/v2/${transactionKey}`, { ...cart, domainUserId: getDomainUserId() }, { credentials: 'include' })
    .catch((err) => console.error('PUT Cart Request Failed', {
      itemCount: cart.items?.length,
      transactionKey,
      error: err.message,
    }))
}
